import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AuthorizationModule } from '@wilson/authorization';
import { FeatureFlagsModule } from '@wilson/feature-flags';
import { RoleAction, RolePermissionSubject, Shift } from '@wilson/interfaces';
import { CanAllShiftBeModifiedPipe } from '@wilson/non-domain-specific/shift-helpers/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { TimelineMultiSelectHelperService } from '../timeline-multi-select-helper.service';
import { AbilityServiceSignal } from '@casl/angular';

@Component({
  selector: 'wilson-move-multi-select-shifts-button',
  imports: [
    CommonModule,
    NzButtonModule,
    TranslateModule,
    FeatureFlagsModule,
    CanAllShiftBeModifiedPipe,
    AuthorizationModule,
    NzTooltipModule,
  ],
  templateUrl: './move-multi-select-shifts-button.component.html',
  styleUrl: './move-multi-select-shifts-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [TimelineMultiSelectHelperService],
})
export class MoveMultiSelectShiftsButtonComponent {
  @Input({ required: true }) selectedShifts!: (Shift & { id: string })[];
  @Input() isOperationOnGoing = false;
  @Input() hasServiceActivity = false;
  @Input() hasWilsonShareActivity = false;
  @Output() moveShiftOperationTriggered = new EventEmitter();
  protected RoleAction = RoleAction;
  protected RolePermissionSubject = RolePermissionSubject;
  protected can = inject(AbilityServiceSignal).can;
}
